﻿import { saveAs } from "file-saver";

export const saveTextAs = (textContent: string, fileName: string) => {
  fileName = fileName || "download.txt";
  textContent = (textContent || "").replace(/\r?\n/g, "\r\n");
  if (window.frames[saveTxtWindow as number]) {
    var saveTxtWindow = window.frames[saveTxtWindow as number] as any;
    if (!saveTxtWindow) {
      saveTxtWindow = document.createElement("iframe");
      saveTxtWindow.id = "saveTxtWindow";
      saveTxtWindow.style.display = "none";
      document.body.insertBefore(saveTxtWindow, null);
      saveTxtWindow = window.frames[saveTxtWindow];
      if (!saveTxtWindow) {
        saveTxtWindow = window.open("", "_temp", "width=100,height=100");
        if (!saveTxtWindow) {
          window.alert("Sorry, download file could not be created.");
          return false;
        }
      }
    }
  }

  var doc = saveTxtWindow.document;
  doc.open("text/html", "replace");

  doc.write(textContent);
  doc.close();
  var retValue = doc.execCommand("SaveAs", null, fileName);
  saveTxtWindow.close();
  return retValue;
};

export function saveFile(xmlString: string, fileName: string) {
  let blob;
  let isFileSaverSupported: boolean = true;
  try {
    isFileSaverSupported = !!new Blob();
  } catch (e) {}

  if (isFileSaverSupported) {
    // only for IE 10+
    try {
      var file = new File([xmlString], fileName + ".xml", {
        type: "application/xml;charset=utf-8",
      });
      saveAs(file);
    } catch (err) {
      blob = new Blob([xmlString], { type: "application/xml" });
      let navigator = window.navigator as Navigator;
      if (navigator["msSaveBlob"]) {
        navigator["msSaveBlob"](blob, fileName + ".xml");
      }
    }
  } else {
    saveTextAs(xmlString, fileName + ".txt");
  }
}
export const readUploadedFileAsText = (file: File) => {
  const temporaryFileReader = new FileReader();

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result);
    };

    if (!file) return;
    temporaryFileReader.readAsText(file);
    //button.value = "";
  });
};
